import React from 'react';
import { Sidebar } from '../../components/shared/Sidebar';
import { DashboardHeader } from '../../components/shared/DashboardHeader';
import { ProfileSection } from '../../components/settings/ProfileSection';
import { SecuritySection } from '../../components/settings/SecuritySection';
import { NotificationPreferences } from '../../components/settings/NotificationPreferences';
import { TwoFactorAuth } from '../../components/security/TwoFactorAuth';
import { ActivityLog } from '../../components/security/ActivityLog';
import { SecurityScore } from '../../components/security/SecurityScore';
import { motion } from 'framer-motion';
export function TenantSettings() {
  return <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors pb-16 lg:pb-0" data-id="element-5226">
      <Sidebar data-id="element-5227" />

      <main className="flex-1 lg:ml-[240px] transition-all duration-300" data-id="element-5228">
        <DashboardHeader data-id="element-5229" />

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8" data-id="element-5230">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-5231">
            <div className="mb-6 lg:mb-8" data-id="element-5232">
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white truncate" data-id="element-5233">
                Settings
              </h1>
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 line-clamp-2" data-id="element-5234">
                Manage your account preferences and security.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-5235">
              <div className="lg:col-span-2 space-y-6 lg:space-y-8" data-id="element-5236">
                <section data-id="element-5237">
                  <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-4 truncate" data-id="element-5238">
                    Profile
                  </h2>
                  <ProfileSection data-id="element-5239" />
                </section>

                <section data-id="element-5240">
                  <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-4 truncate" data-id="element-5241">
                    Security
                  </h2>
                  <div className="space-y-6" data-id="element-5242">
                    <TwoFactorAuth data-id="element-5243" />
                    <SecuritySection data-id="element-5244" />
                  </div>
                </section>

                <section data-id="element-5245">
                  <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-4 truncate" data-id="element-5246">
                    Notifications
                  </h2>
                  <NotificationPreferences data-id="element-5247" />
                </section>

                <section data-id="element-5248">
                  <h2 className="text-lg font-medium text-gray-900 dark:text-white mb-4 truncate" data-id="element-5249">
                    Activity History
                  </h2>
                  <ActivityLog data-id="element-5250" />
                </section>
              </div>

              <div className="space-y-6" data-id="element-5251">
                <SecurityScore data-id="element-5252" />

                <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 transition-colors" data-id="element-5253">
                  <h3 className="font-bold text-gray-900 dark:text-white mb-2 truncate" data-id="element-5254">
                    Privacy Center
                  </h3>
                  <p className="text-sm text-gray-500 dark:text-gray-400 mb-4 break-words" data-id="element-5255">
                    Your data is encrypted and secure. We comply with NDPR
                    regulations.
                  </p>
                  <button className="text-blue-600 dark:text-blue-400 text-sm font-medium hover:underline" data-id="element-5256">
                    View Privacy Policy
                  </button>
                </div>

                <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 transition-colors" data-id="element-5257">
                  <h3 className="font-bold text-gray-900 dark:text-white mb-2 truncate" data-id="element-5258">
                    Data Export
                  </h3>
                  <p className="text-sm text-gray-500 dark:text-gray-400 mb-4 break-words" data-id="element-5259">
                    Download a copy of your personal data and transaction
                    history.
                  </p>
                  <button className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors" data-id="element-5260">
                    Request Data Export
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </main>
    </div>;
}